import { Box, Button, Text } from "@chakra-ui/react";
import { useKBar } from "kbar";
import { ReactNode, useEffect, useState, VFC } from "react";

import { SearchIcon } from "ui/icons";

export const MobileSearchButton: VFC = () => {
  const { query } = useKBar();

  return (
    <Button
      display={["inline-flex", "inline-flex", "none"]}
      variant="subtle"
      aria-label="Search docs"
      onClick={() => query.toggle()}
    >
      <SearchIcon boxSize={5} fill="currentColor" />
    </Button>
  );
};

const Kbd: VFC<{ children: ReactNode }> = ({ children }) => (
  <Box
    as="kbd"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    minW="18px"
    height="18px"
    px={1}
    bg="white"
    border="1px solid"
    borderColor="base.border"
    borderRadius="md"
    fontSize="11px"
    fontFamily="body"
    fontWeight="medium"
    lineHeight={1}
    color="text.tertiary"
  >
    {children}
  </Box>
);

export const SearchBox: VFC = () => {
  const [platform, setPlatform] = useState<"mac" | "windows" | null>(null);

  useEffect(() => {
    if (typeof navigator === "object") {
      setPlatform(navigator.userAgent.includes("Mac") ? "mac" : "windows");
    }
  }, []);

  const isMac = platform === "mac";
  const { query } = useKBar();

  return (
    <Box
      as="button"
      type="button"
      aria-label="Search docs"
      display={["none", "none", "inline-flex"]}
      alignItems="center"
      gap={2}
      width="100%"
      minW={0}
      maxWidth={{ base: "220px", md: "260px" }}
      height="32px"
      px={2.5}
      bg="base.lightBackground"
      border="1px solid"
      borderColor="base.border"
      borderRadius="lg"
      color="text.placeholder"
      fontSize="md"
      transitionProperty="background, border-color"
      transitionDuration="150ms"
      transitionTimingFunction="ease-out"
      outline="none"
      _focusVisible={{ boxShadow: "outline" }}
      _hover={{ bg: "white", borderColor: "base.borderHover" }}
      onClick={() => query.toggle()}
    >
      <SearchIcon boxSize="15px" fill="currentColor" />
      <Text as="span" flex={1} textAlign="left" fontWeight="normal">
        Search docs
      </Text>
      {platform && (
        <Box as="span" display={["none", "none", "inline-flex"]} gap={0.5}>
          <Kbd>{isMac ? "⌘" : "Ctrl"}</Kbd>
          <Kbd>K</Kbd>
        </Box>
      )}
    </Box>
  );
};
